import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useRecoilValue } from 'recoil';

import { Globals } from "root/DataFunctions/BaseDataFns";
// import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
// import { getChildDetails } from "root/DataFunctions/ChildDataFns";
import { childDetailsState } from 'root/recoil/childDetailsState';

import "../styles/subNavbar.scss";

const SubNavBar = () => {

    const subNavbarMenus = phpVars.has_lifestory
        ?
        [
            {id: 1, title: "Posts", name: "", iconSrc: Globals.BaseURL + "/images/icons/child/article.png", isDefault: true },
            {id: 2, title: "Messages", name: "messages", iconSrc: Globals.BaseURL + "/images/icons/child/message.png" },
            {id: 3, title: "LifeStory&Gallery", name: "lifestoryandgallery", iconSrc: Globals.BaseURL + "/images/icons/child/script.png" },
            {id: 4, title: "Diary", name: "child-diary", iconSrc: Globals.BaseURL + "/images/icons/child/diary.png" },
            {id: 5, title: "Family&Friends", name: "family", iconSrc: Globals.BaseURL + "/images/icons/child/tree.png" },
            {id: 6, title: "Resources", name: "resources", iconSrc: Globals.BaseURL + "/images/icons/child/book-shelf.png" },
        ]
        :
        [
            {id: 2, title: "Messages", name: "messages", iconSrc: Globals.BaseURL + "/images/icons/child/message.png", isDefault: true  }
        ];

    const childDetails = useRecoilValue(childDetailsState)

    const location = useLocation();
    const pathArray = location.pathname.split("/");

    const getDefaultMenuName = () =>
    {
        return subNavbarMenus.reduce((cur, rec) =>
        {
            if ( rec.isDefault === true && cur === null )
            {
                return rec.name
            }
            else
            {
                return cur ;
            }
        }, null );
    }

    const parentPage = pathArray[2] === undefined ? getDefaultMenuName() : pathArray[2] ;

    /*let parentPage = pathArray[2];

    if(!parentPage) {
        parentPage = "";
    }else if(parentPage === "posts") {
        parentPage = "";
    }

    let currentPageName = pathArray[pathArray.length - 1];
    if( currentPageName === "child") {
        currentPageName = "";
    }*/

    const menuIconRadius = "35px";
    const indicatorRadius = "35px";

    const sbNavMnPos = 100 / (subNavbarMenus.length - 1);
    const menuIndex = subNavbarMenus.findIndex(x => x.name === parentPage)
    const [activeMenuIndex, setActiveMenuIndex] = useState();

    const avatarUrl = childDetails
    ?
    Globals.APIFolder + '/user/' + childDetails[0].adoptee_user_id + '/avatar?thumb&size=100'
    :
    "";
    
    useEffect(() => {
        setActiveMenuIndex(menuIndex);
    }, []);

    return (
        <div className="sub-nav">
            <div className="sub-nav_profile">
                <a href="/avatar/dressUpMD.php" >
                    <img className="img" src={avatarUrl} alt="Profile Image" title={'Change Avatar'}/>
                </a>
            </div>
            <div className="childNavWrap">
                <div className="childNav">
                    <ul>
                        {subNavbarMenus.map((menu, i) => {
                            return (
                                <li 
                                    key = {menu.id}
                                    className = {parentPage === menu.name ? 'childNav_list active' : 'childNav_list'}
                                    style = {{ left: `calc(${sbNavMnPos * i}% - ${menuIconRadius})` }}
                                    >
                                    <NavLink to={"/child/" + menu.name} onClick={()=>setActiveMenuIndex(i)}>
                                        <span className="childNav_list_icon">
                                            <img className="icon" src={menu.iconSrc} alt={menu.title} />
                                        </span>
                                        <span className="childNav_list_text">{menu.title}</span>
                                    </NavLink>
                                </li>
                            )
                        })}

                        <div 
                            className="indicator"
                            style={{
                                display: activeMenuIndex === -1 ? 'none': 'block',
                                left: `calc(${sbNavMnPos * activeMenuIndex}% - ${indicatorRadius})`
                            }}
                        >
                        </div>
                    </ul>
                </div>
            </div>

        </div>
    );
}

export default SubNavBar;
